class DisabledPeople {
  constructor(
    firstName,
    lastName,
    mainPhoneNumber,
    otherPhoneNumbers,
    address,
    nationalCode,
    birthDate,
    cityId,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.mainPhoneNumber = mainPhoneNumber;
    this.otherPhoneNumbers = otherPhoneNumbers;
    this.address = address;
    this.nationalCode = nationalCode;
    this.birthDate = birthDate;
    this.cityId = cityId;
  }
}
import Vue from 'vue';
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      disabledPeopleId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      disabledPeopleManagmentInformationTableHeaders: [
        { text: 'نام و نام خانوادگی', value: 'fullName', align: 'center' },
        { text: 'شماره اصلی', value: 'phoneNumber', align: 'center' },
        { text: 'شماره دیگر', value: 'otherPhoneNumber', align: 'center' },
        { text: 'آدرس', value: 'address', align: 'center' },
        { text: 'کدملی', value: 'nationalCode', align: 'center' },
        { text: 'تاریخ تولد', value: 'birthDate', align: 'center' },
        { text: 'شهر', value: 'city', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      showDisabledPeopleBrithDate: false,
      tempDisabledPeopleBrithDate: '',
      maxDate: '',
      minDate: '1900/05/20',
      disabledPeoplephoneNumbers: [],
      isActive: false,
      //search
      searchFullName: '',
      searchNationalCode: '',
      searchMainPhoneNumber: '',
      searchCityId: null,
    };
  },
  methods: {
    addPhoneNumber: function () {
      for (let i = 0; i < this.disabledPeoplephoneNumbers.length; i++) {
        if (this.disabledPeoplephoneNumbers[i].text == '') {
          return;
        }
      }
      this.disabledPeoplephoneNumbers.push({
        text: '',
        id: this.disabledPeoplephoneNumbers.length + 1,
      });
    },
    removePhoneNumber: function (id) {
      for (let i = 0; i < this.disabledPeoplephoneNumbers.length; i++) {
        if (id == this.disabledPeoplephoneNumbers[i].id) {
          this.disabledPeoplephoneNumbers.splice(i, 1);
          break;
        }
      }
    },
    disabledPeopleBrithDateChange: function () {
      if (this.disabledPeople.birthDate) {
        this.tempDisabledPeopleBrithDate = Vue.moment(this.disabledPeople.birthDate).format(
          'jYYYY-jMM-jDD',
        );
      }
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن فرد ناتوان';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش فرد ناتوان';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getDisabledPeopleFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.disabledPeople = new DisabledPeople('', '', '', '', '', '', '', null);
      this.disabledPeoplephoneNumbers = [];
      this.tempDisabledPeopleBrithDate = '';
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addDisabledPeopleFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش فرد ناتوان';
        this.$refs.confirm.text = 'از ویرایش فرد ناتوان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف فرد ناتوان';
        this.$refs.confirm.text = 'از حذف فرد ناتوان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addDisabledPeopleFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editDisabledPeopleFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteDisabledPeopleFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.disabledPeopleId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfDisabledPeoplesWithPagination();
    },
    removeFilters: function () {
      this.searchFullName = '';
      this.searchNationalCode = '';
      this.searchMainPhoneNumber = '';
      this.searchCityId = null;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfDisabledPeoplesWithPagination();
    },
    cancelSearch: function () {
      this.searchFullName = '';
      this.searchNationalCode = '';
      this.searchMainPhoneNumber = '';
      this.searchCityId = null;
      this.searchModal = false;
    },
    clearBirthDate: function () {
      this.showDisabledPeopleBrithDate = false;
      this.tempDisabledPeopleBrithDate = '';
      this.disabledPeople.birthDate = '';
    },
  },
};
